import { createSelector } from 'reselect'

import { RootState } from '../types'

export const selectState = createSelector(
  (s: RootState) => s.orders,
  b => b
)

export const selectConfig = createSelector(
  (state: RootState) => state.config,
  c => c
)

export const areOrdersLoading = createSelector(selectState, s => s.loading)

export const getOrders = createSelector(selectState, s => s.data)

export const getTransactionsPageSize = createSelector(selectConfig, c => c.pageSizes['transactions'] || 10)

export const getTransactionFilters = createSelector(selectState, s => s.filters)

export const getTransactionSearchFilter = createSelector(selectState, s => s.searchFilter)
